import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Loader, WarningMessageModal, NoInformationFound } from 'Components';
import MobileAccordion from './MobileAccordion/MobileAccordion';
import './MobileItemList.css';

const overViewTables = ['overviewTemplates', 'overviewJobs', 'overviewOrders', 'overviewInvoices'];

const MobileItemList = (props) => {
  const [section, setSectionName] = useState('');
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);
  const [menuOptionCode, setOptionCode]=useState('');
  
  if (props.data.isLoading) {
    return (
      <div className="mobile-item-list__loader">
        <Loader />
      </div>);
  }
  

  const handleProceed=() => {
   
    props.onOptionClick(menuOptionCode, props.powerTableIndex)
    setOpenWarningMessage(false);
  }
  const handleCancle = ()=> {
    setOpenWarningMessage(false);
  }
 
  const handlOnClick = (optionCode,tableIndex) => {

   if (((((props.data.code === 'orders' || props.data.code ==='supplies') && optionCode=== 'copy') || 
props.data.code === 'templates' && optionCode=== 'newOrder' ||
     props.data.code === 'jobs' && optionCode === 'newOrder') && props.isSupplyWarningON === 'ON'  && !props.isPrepaid)
||
((((props.data.code === 'orders' || props.data.code === 'supplies') && optionCode=== 'newTemplate') || 
props.data.code === 'templates' && optionCode=== 'copy' ||
props.data.code === 'jobs' && optionCode=== 'newTemplate')  && props.isTemplateWarningON === 'ON')
||
 ((((props.data.code === 'orders' || props.data.code === 'supplies') && optionCode=== 'newSubmission') || 
props.data.code === 'jobs' && optionCode=== 'newSubmission' ||
props.data.code === 'templates' && optionCode=== 'newSubmission')  && props.isSubmissionWarningON === 'ON')
) {
  if(((props.data.code === 'orders' || props.data.code === 'supplies') && optionCode=== 'copy')
    || (props.data.code === 'jobs' && optionCode=== 'newOrder')
    || (props.data.code === 'templates' && optionCode=== 'newOrder')){
  setSectionName('Supply')
    }else if(((props.data.code === 'orders' || props.data.code === 'supplies') && optionCode=== 'newTemplate')
    || (props.data.code === 'jobs' && optionCode=== 'newTemplate')
    || (props.data.code === 'templates' && optionCode=== 'copy')){
    setSectionName('Template')
  } else if(((props.data.code === 'orders' || props.data.code === 'supplies') && optionCode=== 'newSubmission')
    || (props.data.code === 'jobs' && optionCode=== 'newSubmission')
    || (props.data.code === 'templates' && optionCode=== 'newSubmission')){
    setSectionName('Submission')
    }
    setOptionCode(optionCode);
    setOpenWarningMessage(true);
    } else {
      props.onOptionClick(optionCode, tableIndex)
    }
    
  }
  return (
    <div className="mobile-item-list">
      {
        props.data.data.length === 0 && (
          overViewTables.includes(props.viewCode) ?
            <div className="mobile-item-list__placeholder-description">
              {props.description}
            </div> : (
              <NoInformationFound
                titleText={props.noInfoTitleText}
                subText={props.noInfoSubText}
                linkText={props.noInfoLinkText}
                link={props.noInfoLink}
              />
            )
        )
      }
      {props.data.data.length !== 0 && props.data.data.map((item, i) => (
        <MobileAccordion
          onExpandClick={() =>
              props.setPageState({
                powerTableIndex: (props.powerTableIndex === i) ? null : i,
                powerTableViewCode: props.viewCode,
              })}
          onPinClick={props.onPinClick}
          onOptionClick={code => handlOnClick(code,i)}
          tableIndex={i}
          active={props.powerTableIndex === i}
          key={item[props.mobileKeys.uniqueKey]}
          data={item}
          hasPinned={props.hasPinned}
          keyPairs={props.keyPairs}
          mobileKeys={props.mobileKeys}
          userName={props.userName}
        />
      ))}
      <div>
        { isWarningMessageOpen &&
        <WarningMessageModal
          onProceed={handleProceed}
          onCancel={handleCancle}
          section={section}
        />
        }
      </div>
    </div>
  );
};

MobileItemList.propTypes = {
  description: PropTypes.shape({}),
  noInfoTitleText: PropTypes.string,
  noInfoLinkText: PropTypes.string,
  noInfoSubText: PropTypes.string,
  noInfoLink: PropTypes.string,
  mobileKeys: PropTypes.shape({
    uniqueKey: PropTypes.string,
  }),
  viewCode: PropTypes.string,
  userName: PropTypes.string,
  powerTableIndex: PropTypes.number,
  hasPinned: PropTypes.bool,
  keyPairs: PropTypes.shape({}),
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    code: PropTypes.string,
  }),
  setPageState: PropTypes.func,
  onOptionClick: PropTypes.func,
  onPinClick: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  };
export default MobileItemList;



// WEBPACK FOOTER //
// ./src/components/MobileItemList/MobileItemList.jsx